<!--
 * @Author: zb
 * @LastEditors: pfy
 * @Date: 2019-08-08 19:37:56
 * @LastEditTime: 2019-09-30 08:51:22
 * @Version: 1.0
 * @Description: 个人中心货源列表展示页面
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 -->
<template>
  <div>
    <div ref="el" class="goods-items-container">
      <template v-if="data.length < 1">
        <div class="goods-item-container no-data-info">暂无匹配数据</div>
      </template>
      <template v-for="(goods, i) of data">
        <div :key="i" class="goods-item-container">
          <div class="goods-item-card">
            <div :class="{'hidden': hasImage}" class="goods-item-picture">
              <template v-if="getFirstUrl(goods)">
                <el-image :src="getFirstUrl(goods) | getImg" lazy />
              </template>
              <template v-else>
                <el-image :src="require('@/assets/img/default_img.png')" lazy />
              </template>
            </div>
            <div class="goods-item-content">
              <div class="content-left">
                <div class="title">
                  {{ goods.startPlaceLabel }}
                  <i class="icon iconfont">—</i>
                  {{ goods.stopPlaceLabel }}
                </div>
                <div>
                  <span>货物信息</span>
                  <span>
                    <i
                      class="type-icon iconfont"
                      :class="goods.goodsTypeLabel==='成品油'||goods.goodsTypeLabel==='液化石油气'||goods.goodsTypeLabel==='润滑油'?
                        'iconyoupin' :
                        goods.goodsTypeLabel==='原油'?'iconyuanyou':'iconhuagongpin' "
                    />
                    {{ goods.goodsTypeLabel }}
                  </span>
                  <el-divider direction="vertical" />
                  <span>{{ goods.goodsName }}</span>
                  <el-divider direction="vertical" />
                  <span>
                    <code style="color: #BE2316">{{ goods.weight }}</code> 吨
                  </span>
                  <!--<el-divider direction="vertical" />-->
                  <!--<span>{{ goods.capacity }}m³</span>-->
                </div>
                <div>
                  <span>运输要求</span>
                  <span>{{ goods.packageTypeLabel }}</span>
                  <el-divider direction="vertical" />
                  <span>{{ goods.payTypeLabel }}</span>
                </div>
                <div>
                  <span>公司名称</span>
                  <span>{{ goods.companyName }}</span>
                  <el-divider direction="vertical" />
                  <span>联系人: {{ goods.contacter }}</span>
                </div>
                <div>
                  <span class="remarks-little">备注说明:{{ goods.remarks }}</span>
                </div>
              </div>
              <div class="content-middle">
                <div>期望运价</div>
                <div class="one">
                  <strong>{{ goods.expectPrice==null?'面议': getMoney(goods.expectPrice) +'元' }}</strong>
                </div>
                <div class="two">截止报价时间</div>
                <div class="there">{{ goods.expireDate }}</div>
              </div>
              <div class="content-right">
                <div class="one">{{ goods.timeMistiming }}</div>
                <div class="two" @click="isLogin() && detificateSuccessSync() && collect(goods)">
                  <i
                    :class="[{iconshoucang1:goods.favoritesFlag==='1'},{iconshoucang:goods.favoritesFlag!=='1'}]"
                    class="iconfont"
                  />
                  <div>{{ goods.favoritesFlag==='1'?'已收藏':'未收藏' }}</div>
                </div>
                <!-- v-permission="['2-1','2-2']" -->
                <el-button v-permission="['2-1','2-2']" size="mini" :disabled="isDisabledOffer(goods)" @click="isLogin() && detificateSuccessSync() && offer(goods)">{{ goods.offerType === 0 ? isDisabledOffer(goods)? '已截止报价':'报价': goods.offerType === 1 ?'已报价': '已拒绝报价' }}</el-button>
                <!--v-login-show-->
                <el-button plain size="mini" @click="isLogin() && details(goods, i, $event)">
                  详情
                  <i :class="{'expand': !goods.hidden}" class="el-icon-d-arrow-right" />
                </el-button>
              </div>
            </div>
          </div>
          <div v-show="!goods.hidden" class="goods-item-details">
            <div class="base-info">
              <div>基本信息</div>
              <div class="info-detail">
                <div class="detail-item">
                  <div style="color: rgb(92,162,62)">
                    <span>起运地</span>
                    {{ goods.startPlaceProvince + goods.startPlaceLabel }}
                  </div>
                  <div>
                    <span>详细地址</span>
                    {{ goods.startPlaceDetail }}
                  </div>
                </div>
                <div class="detail-item">
                  <div style="color: rgb(196,56,62)">
                    <span>目的地</span>
                    {{ goods.stopPlaceProvince + goods.stopPlaceLabel }}
                  </div>
                  <div>
                    <span>详细地址</span>
                    {{ goods.stopPlaceDetail }}
                  </div>
                </div>
                <div class="detail-item">
                  <div>
                    <span>公司名称</span>
                    {{ goods.companyName }}
                  </div>
                  <div>
                    <span>运输品类</span>
                    {{ goods.packageTypeLabel }}
                  </div>
                  <div style="display: flex;justify-content: space-between">
                    <div style="width: 50%">
                      <span>承载能力</span>
                      {{ goods.weight }}吨
                    </div>
                  </div>
                </div>
                <div class="detail-item">
                  <div style="width: 50%">
                    <span>运输方式</span>
                    {{ goods.transportTypeLabel }}
                  </div>
                </div>
                <div class="detail-item">
                  <div>
                    <span>起运时间</span>
                    {{ goods.startTransportDate }}
                  </div>
                  <div>
                    <span>结束时间</span>
                    {{ goods.mostLateDeliveryDate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="contact-info">
              <div>联系人信息</div>
              <ul>
                <li>
                  <span>联系人</span>
                  {{ goods.contacter }}
                </li>
                <li>
                  <span>联系电话</span>
                  {{ goods.contacterTel | safePhone }}
                </li>
              </ul>
            </div>
            <div class="imgs-info">
              <div>图片</div>
              <ul v-if="fileUrl(goods)" v-viewer>
                <li v-for="(item , index) in fileUrl(goods)" :key="index">
                  <el-image :src="item | getImg" lazy />
                </li>
              </ul>
              <ul v-else v-viewer>
                <li>
                  <el-image :src="require('@/assets/img/default_img.png')" lazy />
                </li>
              </ul>
              <div>备注</div>
              <span>{{ goods.remarks }}</span>
            </div>
          </div>
        </div>
      </template>
      <div class="goods-items-pagination">
        <el-pagination
          :current-page="pagination.pageNo"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper,total, sizes"
          @current-change="changeCurrent"
          @size-change="changeSize"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Page } from '@/utils/commonDataModel'
import mixinsFunction from '@/utils/mixinsFunction'
import dictionary from '../dataConfig/dictionary.json'
export default {
  name: 'GoodsItem',
  mixins: [mixinsFunction],
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 父组件传来的货源数据列表
    showData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: function() {
    return {
      goodsInfo: dictionary.goodsInfo,
      hasImage: false,
      viewControl: {
        showDetails: false,
        loading: true,
        useInternal: false
      },
      data: [],
      pagination: new Page()
    }
  },
  computed: {
    fileUrl(goods) {
      // 图片回调
      return goods => {
        if (goods.fileUrl == null || goods.fileUrl === '') {
          return false
        }
        return goods.fileUrl.split(',').filter(n => n) // 数组去空
      }
    },
    getFirstUrl(goods) {
      // 图片回调
      return goods => {
        return goods.fileUrl.split(',')[0] // 数组去空
      }
    }
  },
  watch: {
    showData: {
      handler: function() {
        this.data = JSON.parse(JSON.stringify(this.showData.rows))
        for (let i = 0; i < this.data.length; i++) {
          this.data[i].hidden = true
        }
        this.pagination.total = this.showData ? this.showData.total : 0
        this.viewControl.loading = false
      },
      deep: true
    }
  },
  methods: {
    isDisabledOffer(goods) {
      // 如果已经报价则不再报价
      if (goods.offerType && goods.offerType != 0) {
        return true
      }
      // 报价时间已经截止则不再报价
      if (goods.expireDate) {
        if (goods.expireDate instanceof Date) {
          return goods.expireDate.getTime() < Date.now() - Date.now() % (1000 * 60 * 60 * 24)
        } else {
          return Date.parse(goods.expireDate) < Date.now() - Date.now() % (1000 * 60 * 60 * 24)
        }
      }
      return false
    },
    // 数字转为货币
    getMoney(num) {
      return Number(num).toLocaleString(undefined, {
        style: 'currency',
        currency: 'CNY'
      })
    },
    getDate() {
      return new Date().toLocaleString()
    },
    // 打开报价弹窗
    offer(goods) {
      if (goods.offerType != 1) {
        this.$emit('offer', goods)
      }
    },
    // 收藏
    collect(goods) {
      this.$emit('favorites', goods)
    },
    // 详情
    details(goods, index, event) {
      // 当前是展开的只需关闭
      if (goods.hidden) {
        // 把展开的关闭
        this.data.forEach((item, position) => {
          // 要关闭的元素
          if (!item.hidden) {
            const lastState = event.target.getBoundingClientRect()
            item.hidden = true
            // 如果当前元素比要展开的元素在前面， 需要向上滚动
            if (position < index) {
              setTimeout(() => {
                this.computePositionScroll(event.target, lastState)
              }, 50)
            }
          }
        })
      }
      goods.hidden = !goods.hidden
    },
    changeSize(size) {
      this.pagination.pageSize = size
      this.$emit('refreshPage', this.pagination)
      this.viewControl.loading = true
    },
    changeCurrent(current) {
      this.pagination.pageNo = current
      this.$emit('refreshPage', this.pagination)
      this.viewControl.loading = true
    }
  }
}
</script>
<style lang="scss" scoped>
.remarks-little {
  // width: 600px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden; //盒子溢出隐藏
  line-height: 18px;
  &::after{
          content: "" !important;
  }
}
code {
  font-family: MicrosoftYaHei;
}
$perfix: "goods-item";
$main-color: rgb(190, 35, 22);

.no-data-info {
  background-color: #fff;
  width: 100%;
  text-align: center;
  margin-top: 8px;
  height: 48px;
  line-height: 48px;
  font-size: 15px;
}

.#{$perfix}-container {
  *::selection {
    background-color: rgba(0, 0, 0, 0) !important;
  }
  width: 100%;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
  border: 1px solid #ebeef5;
  margin-bottom: 10px;
  border-radius: 4px;
  position: relative;
  .#{$perfix}-card {
    display: flex;
    border-radius: 4px;
    background-color: #fff;
    padding: 12px;
    overflow: hidden;
    color: #303133;
    transition: 0.3s;
    align-items: center;
    border: 1px solid #ebeef5;
    .#{$perfix}-picture {
      height: 168px;
      display: inline-block;
      width: 225px;
      &.hidden {
        display: none;
      }
      .el-image {
        height: 100%;
        width: 225px;
        .image-slot {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
          background: #f5f7fa;
          color: #909399;
          font-size: 14px;
          [class*=" el-icon-"],
          [class^="el-icon-"] {
            font-family: element-icons !important;
            font-style: normal;
            font-weight: 400;
            font-variant: normal;
            text-transform: none;
            line-height: 1;
            vertical-align: baseline;
            display: inline-block;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            font-size: 30px;
          }
        }
      }
    }

    .#{$perfix}-content {
      display: flex;
      padding-left: 24px;
      height: 171px;
      width: calc(100% - 248px);
      align-items: flex-start;
      justify-content: space-between;
       >div{
        height: 100%;
      }
      .content-left {
        width: 60%;
        color: #333333;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        span:first-child {
          color: #555555;
        }
        span:first-child::after {
          color: #555555;
          content: " : ";
        }

        .title {
          color: $main-color;
          font-weight: bold;
          white-space: nowrap;
          height: 24px;
          font-size: 24px;
          margin-bottom: 9px;
          width: 100%;
          i {
            color: initial !important;
            font-weight: initial !important;
            font-size: 30px !important;
            margin: 0 0;
            padding: 0 0;
            width: 24px;
          }
        }
      }
      .content-middle {
        text-align: center;
        font-size: 14px;
        width: 20%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        >* {
          height: 28px;
          &:nth-child(even) {
            margin-bottom: 17px;
          }
          &:first-child {
            margin-top: 10px;
          }
        }
        > div {
          padding: 4px 0px;
          width: 100%;
          &:nth-child(odd) {
            color: #ccc;
          }
        }

        .one {
          color: $main-color;
          strong {
            white-space: nowrap;
            margin-right: 2rem;
            float: right;
            font-size: 24px;
          }
        }

        .there {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
      .content-right {
        width: 15%;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        flex-direction: column;
        >*{
         &:first-child {
            margin-top: 10px;
           }
        }
        > div {
          padding: 4px 0px;
        }
        .one {
          color: #ccc;
          white-space: nowrap;
          // overflow: hidden;
          text-overflow: ellipsis;
        }
        .two {
          width: 3rem;
          text-align: center;
          cursor: pointer;
          margin-right: 16px;
          i {
            color: #be2316;
          }
        }
        /deep/ .el-button {
          background-color: #be2316;
          color: white;
          border-color: #be2316;
          width: 80px;
        }

        /deep/ .el-button.is-plain {
          background-color: white;
          color: #be2316;
          border-color: #be2316;
          padding: 7px 4px !important;
          // width: 56px;
          span > i {
            transition: 1s all;
            transform: rotateZ(90deg);
            &.expand {
              transform: rotateZ(-90deg);
            }
          }
        }
      }
    }
  }
  @keyframes show {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .#{$perfix}-details {
    width: 100%;
    background-color: rgb(250, 251, 255);
    transition: all 0.8s ease-in-out;
    z-index: -1;
    padding-bottom: 16px;
    display: block;
    animation: show 0.8s ease-in-out;
    clip: rect(0 auto 0 0);
    > div {
      padding: 16px 16px;
      width: calc(100% - 32px);
      font-size: 14px;
      border-bottom: 1px solid #ebeef5;
      &:last-child {
        border-bottom: none !important;
      }

      ul {
        li {
          span:after {
            content: " : ";
          }
        }
      }

      > div {
        font-size: 15px;
        font-weight: bold;
        color: $main-color;
        margin-bottom: 24px;
      }
      &.base-info {
        span:after {
          content: " : ";
        }
        .info-detail {
          display: flex;
          flex-direction: column;
          color: #000000;
          font-weight: normal;
          margin-bottom: 0;
          .detail-item {
            display: flex;
            margin-bottom: 24px;
            div {
              width: 33%;
            }
          }
        }
      }
      &.contact-info {
        ul {
          width: 100%;
          display: flex;
          // columns: 2;
          // column-width: 25%;
          // column-gap: 16px;
          > li {
            height: 16px;
            line-height: 16px;
            padding: 4px 0px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 33%;
          }
        }
      }

      &.imgs-info {
        ul {
          display: inline-block;
          li {
            float: left;
            margin-right: 24px;
            margin-bottom: 12px;
            &:last-child {
              margin-right: 0px !important;
            }
            .el-image {
              height: 124px;
              width: 136px;
            }
          }
        }
      }
    }
  }
}

.goods-items-pagination {
  width: 100%;
  margin-top: 24px;
}
.type-icon {
  color: #f3b348;
}
</style>

